<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="homeGoods">
        <div class="title" @click="showTips">
          <img src="../assets/images/images/homeGoodstitle.png" alt />
        </div>
        <div class="goodsList">
          <template v-for="(item) in goodsList"> 
            <div :key="item.id">
              <!--四个图-->
              <div class="fourGoods" v-if="item.thumbs.length >= 4" :key="item.id">
                <div class="goodsHead" @click="goShopDetail(item.shop.id)">
                  <div>
                    <img :src="item.shop.small_logo_url" alt />
                  </div>
                  <div>{{ item.shop.name }}</div>
                </div>
                <div class="imglist" @click="goGoods(item)">
                  <img :src="item.thumbs[0].small_path_url" alt />
                  <img :src="item.thumbs[1].small_path_url" alt />
                  <img :src="item.thumbs[2].small_path_url" alt />
                  <img :src="item.thumbs[3].small_path_url" alt />
                </div>
                <div class="bottom">
                  <div @click="goMyShop">申请入驻</div>
                  <div @click="goShop(item.shop.id)">进店看看》</div>
                </div>
              </div>
              <!--一个图-->
              <div class="fourGoods" v-if="item.thumbs.length ==1" :key="item.id">
                <div class="goodsHead" @click="goShopDetail(item.shop.id)">
                  <div>
                    <img :src="item.shop.small_logo_url" alt />
                  </div>
                  <div>{{ item.shop.name }}</div>
                </div>
                <div class="imglist2" @click="goGoods(item)">
                  <img :src="item.thumbs[0].small_path_url" alt />
                </div>
                <div class="bottom">
                  <div @click="goMyShop">申请入驻</div>
                  <div @click="goShop(item.shop.id)">进店看看》</div>
                </div>
              </div>
              <!--两个图-->
              <div class="fourGoods" v-if="item.thumbs.length ==2" :key="item.id">
                <div class="goodsHead" @click="goShopDetail(item.shop.id)">
                  <div>
                    <img :src="item.shop.small_logo_url" alt />
                  </div>
                  <div>{{ item.shop.name }}</div>
                </div>
                <div class="imglist3" @click="goGoods(item)">
                  <img :src="item.thumbs[0].small_path_url" alt />
                  <img :src="item.thumbs[1].small_path_url" alt />
                </div>
                <div class="bottom">
                  <div @click="goMyShop">申请入驻</div>
                  <div @click="goShop(item.shop.id)">进店看看》</div>
                </div>
              </div>
              <!--三个图-->
              <div class="fourGoods" v-if="item.thumbs.length ==3" :key="item.id">
                <div class="goodsHead" @click="goShopDetail(item.shop.id)">
                  <div>
                    <img :src="item.shop.small_logo_url" alt />
                  </div>
                  <div>{{ item.shop.name }}</div>
                </div>
                <div class="imglist4" @click="goGoods(item)">
                  <div>
                    <img :src="item.thumbs[0].small_path_url" alt />
                  </div>
                  <div>
                    <img :src="item.thumbs[1].small_path_url" alt />
                    <img :src="item.thumbs[2].small_path_url" alt />
                  </div>
                </div>
                <div class="bottom">
                  <div @click="goMyShop">申请入驻</div>
                  <div @click="goShop(item.shop.id)">进店看看》</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
let me;
import { ActionSheet,Dialog  } from "vant";
import { getData } from "../Interface/http.js";
export default {
  name: "homeGoods",
  data() {
    return {
      goodsList: [], //商品列表
      loginStatus: false, //是否已经登录
      userInfoData: "",
      loading: false,
      finished: false,
      pageNum: 1,
    };
  },
  props: ['vipStatus','leftDay'],
  components: {
    ActionSheet,
  },
  computed: {
  },
  methods: {
    //跳转到店铺信息页面
    goShopDetail(id){
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "info",
          id: id,
        },
      });
    },
    //跳转店铺详情页
    goGoods(item) {
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "info",
          id: item.shop.id,
          obj: item,
        },
      });
    },
    onLoad() {
      me.getGoodsList();
    },
    //展示提示信息
    showTips() {
      this.$toast("已开通门店的用户发布的家纺宝贝会在下方区域展示！");
    },
    getUserInfo() {
      getData("/user/info", {
        token:
          localStorage.getItem("token") != ""
            ? localStorage.getItem("token")
            : "123456",
      })
        .then((res) => {
          if (res.code == 0) {
            me.userInfoData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goShop(id) {
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "goods",
          id: id,
        },
      });
    },
    /**获取商品列表信息 */
    getGoodsList() {
      getData("/realtime-goods", {
        page: me.pageNum,
      }).then((res) => {
        me.loading = false;
        me.pageNum++;
        if (res.data.length != 0) {
          me.goodsList = me.goodsList.concat(res.data);
        } else {
          me.finished = true;
        }
      });
    },
    login() {
      getData("/oauth/redirect/wechat").then(res => {
        localStorage.setItem("startPage", "home");
        window.location.href = res.data.redirect_url;
      });
    },
    //跳转到续费页面
    goXFPage() {
      this.$router.push({
        name: "continuePay",
        query: {
          id: me.userInfoData.shop_id,
        },
      });
    },
    //判断跳转我的店铺还是申请店铺
    goMyShop() {
      let me = this;
      if (!me.loginStatus) {
        //如果未登录
        me.login();
        return;
      }
      if (me.leftDay.type == "over") {
        Dialog.confirm({
          // title: "下架",
          message: "你之前的门店已过期，是否续费",
        })
          .then(() => {
            me.goXFPage();
          })
          .catch(() => {
            console.log("取消");
          });
        return;
      }
      if (me.userInfoData.shop_id == 0 || !me.userInfoData.shop_status) {
        if (me.vipStatus && me.vipStatus.type == "on") {
            this.$toast("后台正在审核，请勿重新申请！");
            return;
        }
        this.$router.push({
          name: "addShop",
        });
      } else {
        Dialog.confirm({
          message: '您已开通过店铺，是否进入自己的店铺管理中心',
        })
          .then(() => {
            me.$router.push({
              name: "mangerMyShop",
              query: {
                shop_id: me.userInfoData.shop_id,
              },
            });
          })
          .catch(() => {
          });      
      }
    },
  },
  created() {
    me = this;
  },
  mounted() {
    me.getUserInfo();
    if (
      localStorage.getItem("token") == null ||
      localStorage.getItem("token") == "123456"
    ) {
      this.loginStatus = false;
    } else {
      this.loginStatus = true;
    }
  },
};
</script>
<style scoped>
.homeGoods {
  width: 355px;
  margin: 0 auto;
  margin-top: 10px;
}
.title {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.title img {
  width: 100%;
  height: 20px;
  margin: 0 auto;
}

.fourGoods {
  width: 175px;
  height: 202px;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 5px;
  position: relative;
}
.goodsHead {
  display: flex;
  color: #666666;
  font-size: 13px;
  align-items: center;
  margin-left: 13px;
  padding-top: 8px;
}
.goodsHead img {
  width: 24px;
  height: 24px;
}
.goodsHead > div:nth-child(2) {
  width: 100px;
  text-align: left;
  margin-left: 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.imglist2 img {
  width: 140px;
  height: 140px;
}
.imglist3 img {
  width: 70px;
  height: 140px;
}
.imglist3 img:nth-child(2) {
  margin-left: 1px;
}
.imglist4 {
  display: flex;
  justify-content: center;
  padding-bottom: 3px;
}
.imglist4 div {
  width: 70px;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 2px;
}
.imglist4 div:nth-child(1) img {
  width: 70px;
  height: 140px;
}
.imglist4 div:nth-child(2) img {
  width: 68px;
  height: 69px;
}
.imglist {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.imglist img {
  width: 70px;
  height: 70px;
  margin-top: 1px;
}
.imglist img:nth-child(2),
.imglist img:nth-child(4) {
  margin-left: 1px;
}
.bottom {
  display: flex;
  color: #666666;
  font-size: 11px;
  position: absolute;
  width: 84%;
  margin-left: 8%;
  bottom: 5px;
}
.bottom div {
  flex-grow: 1;
}
.bottom div:nth-child(1) {
  text-align: left;
}
.bottom div:nth-child(2) {
  text-align: right;
}

.goodsList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>